interface SmartBeadMarkProps {
  size?: number
  /** Animate the signal arcs (the NFC "broadcast" pulse). Falls back to static
   *  under prefers-reduced-motion. */
  animated?: boolean
  className?: string
}

/** Ring beads, clockwise from 3 o'clock (bottom-center left open for the hero). */
const RING: { cx: number; cy: number; fill: string }[] = [
  { cx: 198, cy: 120, fill: '#ff2d95' },
  { cx: 187, cy: 159, fill: '#fb923c' },
  { cx: 159, cy: 187, fill: '#facc15' },
  { cx: 81, cy: 187, fill: '#22d3ee' },
  { cx: 53, cy: 159, fill: '#38bdf8' },
  { cx: 42, cy: 120, fill: '#a855f7' },
  { cx: 53, cy: 81, fill: '#ff2d95' },
  { cx: 81, cy: 53, fill: '#fb923c' },
  { cx: 120, cy: 42, fill: '#a3e635' },
  { cx: 159, cy: 53, fill: '#22d3ee' },
  { cx: 187, cy: 81, fill: '#a855f7' },
]

const ARCS: { d: string; opacity: number; delay: string }[] = [
  { d: 'M98 164 A 30 30 0 0 1 142 164', opacity: 0.9, delay: '0s' },
  { d: 'M88 154 A 46 46 0 0 1 152 154', opacity: 0.5, delay: '.3s' },
  { d: 'M80 144 A 62 62 0 0 1 160 144', opacity: 0.26, delay: '.6s' },
]

/**
 * The KandiTag "smart bead" brand mark — a neon kandi-bead ring with a glowing
 * lime hero bead broadcasting a Wi-Fi-style signal. Animate it where the user is
 * tapping or waiting (scan, launch, load); use the static mark for chrome.
 */
export const SmartBeadMark = ({ size = 96, animated = false, className }: SmartBeadMarkProps) => {
  const reduced =
    typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  const pulse = animated && !reduced

  return (
    <svg
      viewBox="0 0 240 240"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="KandiTag"
    >
      {RING.map((b, i) => (
        <circle key={i} cx={b.cx} cy={b.cy} r="12" fill={b.fill} />
      ))}
      <circle cx="120" cy="196" r="26" fill="#0a1020" />
      <circle
        cx="120"
        cy="196"
        r="22"
        fill="#a3e635"
        style={{ filter: 'drop-shadow(0 0 14px #a3e635)' }}
      />
      <circle cx="120" cy="196" r="9" fill="#05060f" />
      {ARCS.map((a, i) => (
        <path
          key={i}
          d={a.d}
          fill="none"
          stroke="#a3e635"
          strokeWidth="5"
          strokeLinecap="round"
          opacity={pulse ? undefined : a.opacity}
          className={pulse ? 'kt-sig' : undefined}
          style={pulse ? { animationDelay: a.delay } : undefined}
        />
      ))}
    </svg>
  )
}
